<p-dialog id="test" header="{{ 'businessStatus.details.tradeEvents.tradeEventDetail' | translate }}"
          [visible]="tradeEventDialogVisible()"
          (onHide)="onDialogHide()" [resizable]="false"
          [modal]="true"
          [draggable]="true"
          appendTo="body">
  <div class="p-3 pb-0">
    @if (messageState()) {
      <div class="mb-3">
        <p-message id="trade-event-message" variant="outlined" [severity]="messageState()?.severity">
          {{ messageState()?.message }}
        </p-message>
      </div>
    }
    <div class="flex flex-row justify-content-between mb-5">
      <div class="flex flex-column gap-2">
        <div class="flex flex-row align-items-center">
          <label for="kunde_name" class="flex w-10rem">{{ "administration.customer.bank" | translate }}</label>
          <input id="kunde_name" type="text" [disabled]="true" pInputText class="text-right w-18rem"
                 [value]="geschaeft().kunde?.name ?? ''" />
        </div>
        <div class="flex flex-row align-items-center">
          <label for="tradeId"
                 class="justify-content-start w-10rem">{{ "businessStatus.details.businessNumber" | translate }}</label>
          <input id="tradeId" type="text" [disabled]="true" pInputText class="text-right w-18rem"
                 [value]="tradeIdWithoutVersion" />
        </div>
        <div class="flex flex-row align-items-center">
          <label for="tradeId"
                 class="justify-content-start w-10rem">{{ "businessStatus.tableHeader.businessType" | translate }}</label>
          <input type="text" [disabled]="true" pInputText class="text-right w-18rem"
                 [value]=" 'common.productLabel.' + geschaeft().typ?.richtung + '_' + geschaeft().typ?.simpleHgType | translate" />
        </div>
      </div>
      <div class="flex align-self-start">
        <div class="flex flex-row align-items-center">
          <label for="date" class="w-5rem">{{ "administration.ricMds.date" | translate }}</label>
          <input id="date" type="text" [disabled]="true" pInputText class="text-right w-18rem"
                 [value]="currentDate| date: 'dd.MM.yyyy'" />
        </div>

      </div>
    </div>

    @if (geschaeft() && geschaeft().tradeEvents) {
      <p-table class="mt-3" [style]="{ width: '92rem' }" scrollHeight="440px" scrollable="true"
               [value]="geschaeft().tradeEvents!" [paginator]="true" [rows]="100" paginatorPosition="both"
               [rowsPerPageOptions]="[10, 25, 50, 100, 250]" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="eventDate">{{ "businessStatus.details.dateTime" | translate }}
              <p-sortIcon field="eventDate"></p-sortIcon>
            </th>
            <th pSortableColumn="tradeIdVersionAsInt">{{ "businessStatus.details.tradeEvents.version" | translate }}
              <p-sortIcon field="tradeIdVersionAsInt"></p-sortIcon>
            </th>
            <th pSortableColumn="erfasserId">{{ "businessStatus.details.tradeEvents.inventor" | translate }}
              <p-sortIcon field="erfasserId"></p-sortIcon>
            </th>
            <th pSortableColumn="contactName">{{ "businessStatus.details.tradeEvents.businessPartner" | translate }}
              <p-sortIcon field="contactName"></p-sortIcon>
            </th>
            <th pSortableColumn="balance">{{ "businessStatus.details.tradeEvents.actInventory" | translate }}
              <p-sortIcon field="balance"></p-sortIcon>
            </th>
            <th pSortableColumn="amount">{{ "businessStatus.details.tradeEvents.amount" | translate }}
              <p-sortIcon field="amount"></p-sortIcon>
            </th>
            <th pSortableColumn="type">{{ "businessStatus.details.tradeEvents.change" | translate }}
              <p-sortIcon field="type"></p-sortIcon>
            </th>
            <th pSortableColumn="balanceNew">{{ "businessStatus.details.tradeEvents.newInventory" | translate }}
              <p-sortIcon field="balanceNew"></p-sortIcon>
            </th>
            <th pSortableColumn="effectiveZins">{{ "businessStatus.details.tradeEvents.interestRate" | translate }}
              <p-sortIcon field="effectiveZins"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tradeEvent>
          <tr>
            <td>{{ tradeEvent.eventDate | date: "dd.MM.yyyy HH:mm:ss" }} Uhr</td>
            <td>{{ tradeEvent.tradeIdVersionAsInt }}</td>
            <td>{{ tradeEvent.erfasserId }}</td>
            <td>{{ tradeEvent.contactName }}</td>
            <td class="text-right">{{ tradeEvent.balance | number: '1.2-2' }} {{ tradeEvent.currency }}</td>
            <td class="text-right">{{ tradeEvent.amount | number: '1.2-2' }} {{ tradeEvent.currency }}</td>
            <td>{{ "businessStatus.details.tradeEvents." + tradeEvent.type | translate }}</td>
            <td class="text-right">{{ tradeEvent.newBalance | number: '1.2-2' }} {{ tradeEvent.currency }}</td>
            <td>{{ tradeEvent.effectiveZins | number: "1.3-3" }}%</td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <div class="flex justify-content-center w-full mt-3 border-1 border-solid surface-border border-round p-3">
        <span>{{ 'businessStatus.details.tradeEvents.noEntries' | translate }}</span>
      </div>
    }
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-between w-full p-3 pt-0">
      <p-button severity="secondary" variant="outlined" label="{{ 'common.back' | translate }}"
                (click)="onDialogHide()" />
      <div class="flex">
        <p-button variant="outlined" label="{{ 'common.print' | translate }}" class="mr-2"
                  (click)="printTradeEventsInPDF()" />
        <p-button variant="outlined" label="{{ 'common.export' | translate }}" (click)="exportTradeEventsInCSV()" />
      </div>
    </div>
  </ng-template>
</p-dialog>
